import { ZButton } from "@/shared/components/button";
import ModalCloseIcon from "@/shared/icons/modal-close";
import { Modal, ModalBody, ModalContent, ModalHeader } from "@nextui-org/react";

interface ExitWithoutSavingModalProps {
  isOpen: boolean;
  toggleModal: () => void;
  onExitWithoutSaving: () => void;
  onSaveAndExit: () => void;
  isLoading?: boolean;
}

const ExitWithoutSavingModal = ({
  isOpen,
  toggleModal,
  onExitWithoutSaving,
  onSaveAndExit,
  isLoading = false
}: ExitWithoutSavingModalProps) => {
  const handleExitWithoutSaving = () => {
    if (isLoading) return;
    onExitWithoutSaving();
    toggleModal();
  };

  const handleSaveAndExit = () => {
    if (isLoading) return;
    void onSaveAndExit();
  };

  return (
    <Modal isOpen={isOpen} size="md" hideCloseButton={true} onClose={toggleModal}>
      <ModalContent>
        <ModalHeader className="self-center">
          <button
            role="button"
            aria-label="Close"
            onClick={toggleModal}
            className="absolute appearance-none select-none top-1 right-1 rtl:left-1 rtl:right-[unset] p-2 text-foreground-500
        rounded-full hover:bg-default-100 active:bg-default-200 tap-highlight-transparent outline-none data-[focus-visible=true]:z-10
        data-[focus-visible=true]:outline-2 data-[focus-visible=true]:outline-focus data-[focus-visible=true]:outline-offset-2 text-[16px]"
            type="button"
          >
            <ModalCloseIcon />
          </button>
          <div className="flex flex-col items-center justify-center gap-2">
            <p className="text-[20px] font-medium">
              Exit without saving?
            </p>
          </div>
        </ModalHeader>
        <ModalBody className="self-center items-center justify-center w-full">
          <p className="text-center text-sm text-gray-500">All new edits to this setting will be lost.</p>

          <div className="flex gap-3 w-full mt-4">
            <ZButton
              variant="bordered"
              onClick={handleExitWithoutSaving}
              disabled={isLoading}
              className="flex-1"
            >
              Exit without Saving
            </ZButton>
            <ZButton
              onClick={handleSaveAndExit}
              isLoading={isLoading}
              disabled={isLoading}
              className="flex-1"
              color="primary"
            >
              Save & Exit
            </ZButton>
          </div>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ExitWithoutSavingModal;
